import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { AlarmType } from '../enums/alarm-type.enum';

@Pipe({
  name: 'alarmTypeDescription',
  standalone: true,
})
export class AlarmTypeDescriptionPipe implements PipeTransform {
  private translationKeys: Record<AlarmType, string> = {
    [AlarmType.OPERATING_HOURS]: this.translate('modules.notification.alarmRuleAddEdit.description.operatingHours'),
    [AlarmType.OPERATING_HOURS_CONTRACT]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.contractOperatingHours',
    ),
    [AlarmType.TANK_FILL_LEVEL]: this.translate('modules.notification.alarmRuleAddEdit.description.tankLevel'),
    [AlarmType.FAULTS]: this.translate('modules.notification.alarmRuleAddEdit.description.fault'),
    [AlarmType.TOTAL_COSTS]: this.translate('modules.notification.alarmRuleAddEdit.description.totalCost'),
    [AlarmType.DAMAGE_COSTS]: this.translate('modules.notification.alarmRuleAddEdit.description.violenceDamageCosts'),
    [AlarmType.REPAIR_COSTS]: this.translate('modules.notification.alarmRuleAddEdit.description.repairCosts'),
    [AlarmType.GUARANTEE]: this.translate('modules.notification.alarmRuleAddEdit.description.guarantee'),
    [AlarmType.FULL_SERVICE_CONTRACT_END]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.fullServiceContractEnd',
    ),
    [AlarmType.LEASING_SERVICE_CONTRACT_END]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.leasingOrRentalContractEnd',
    ),
    [AlarmType.GEOFENCE_VIOLATION]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.geofenceViolation',
    ),
    [AlarmType.GLOBAL_GEOFENCE_VIOLATION]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.globalGeofenceViolation',
    ),
    [AlarmType.THEFT_PROTECTION]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.theftProtection',
    ),
    [AlarmType.TIMEFENCING]: this.translate('modules.notification.alarmRuleAddEdit.description.timefence'),
    [AlarmType.TRANSPORT_TASK_CREATION]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.transportCreation',
    ),
    [AlarmType.TRANSPORT_TASK_RETURNED]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.transportStatusChanged',
    ),
    [AlarmType.NEW_DAMAGE_ADDED]: this.translate('modules.notification.alarmRuleAddEdit.description.newDamageAdded'),
    [AlarmType.INACTIVE_TELEMATICS_UNIT]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.inactiveTelematicsUnit',
    ),
    [AlarmType.BATTERY_VOLTAGE]: this.translate('modules.notification.alarmRuleAddEdit.description.batteryVoltage'),
    [AlarmType.DEF_TANK_LEVEL]: this.translate('modules.notification.alarmRuleAddEdit.description.defTankLevel'),
    [AlarmType.TELEMATICS_UNIT_BATTERY_STATUS]: this.translate(
      'modules.notification.alarmRuleAddEdit.description.trackerBatteryStatus',
    ),
  };

  constructor(private languageService: LanguageService) {}

  transform(value: AlarmType): string {
    return this.translationKeys[value] || this.translate('modules.notification.base.alarmTypes.unknown');
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
